import { ApiAttributionModel } from "@incendium/api";
import Loading from "Components/Loading/Loading";
import CustomerValueCohort from "features/analytics/components/CustomerValueCohort";
import { useAttributionContext } from "Providers/AttributionProvider";

function CustomerValueCohortPage() {
  const { model, isLoaded } = useAttributionContext();
  if (!isLoaded) {
    return <Loading fullHeight />;
  }
  return <CustomerValueCohort model={model || ApiAttributionModel.EBA} />;
}

export default CustomerValueCohortPage;
